import React, { useEffect, useState, useRef } from 'react';
import './blogs_busq.css'
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SkeletonCard from "../../../components/Skeleton/SkeletonCard";

const Blogs_busq = ({ contenido }) => {
    const [t2] = useTranslation("busqueda");
    const [t] = useTranslation("ideas_libertad");
    //const [loading, setLoading] = useState(true); el correcto
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [offset, setOffset] = useState(14);
    const [loadingMore, setLoadingMore] = useState(false);
    const [activeCategory, setActiveCategory] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [hasMore, setHasMore] = useState(true);
    const [sortOrder, setSortOrder] = useState("recent");

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("es-MX", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        }).toUpperCase();
    };

    const numero = () => {
        const i = Math.floor(Math.random() * 5) + 1

        return i

    }

    if (!contenido || !contenido.blogNs || contenido.blogNs.length === 0) {
        return <div></div>;
    }

    const getReadingTime = (txtresumen) => {
        if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {

            const partes = txtresumen.split("||");

            if (partes.length > 1 && partes[1].trim() !== "") {
                return partes[1].trim() + " MIN";
            }
        }

        const i = Math.floor(Math.random() * 5) + 1;
        return i + " MIN";
    };

    const cleanResumen = (txt) => {
        if (!txt) return "";
        return txt.split("||")[0];
    };

    const truncateText = (text, limit) => {
        if (!text) return "";

        const cleanText = cleanResumen(text);

        if (cleanText.length <= limit) {
            return cleanText;
        }

        return cleanText.slice(0, limit).trim() + "...";
    };

    return (
        <>
            <h2 _ngcontent-ng-c2327341559="" class="busqueda-page__section-title">Blogs</h2>
            <div class="_ngcontent-ng-c2327341559 _nghost-ng-c732107720">
                <section class="blog-page">
                    <div class="_nghost-ng-c732107720">
                        <section aria-label="Historias con imagen" class="blog-image-cards-row">
                            <div class="blog-image-cards-row__inner">
                                {loading
                                    ? Array.from({ length: 6 }).map((_, i) => (
                                        <SkeletonCard key={i} type="imageCard" />
                                    ))
                                    : contenido.blogNs.map((item, i) => (

                                        <article class="blog-image-cards-row__card" tabindex="0">
                                            <a href={'/blog/' + item.tag}><img
                                                loading="lazy" src={item.urlImagen} alt={item.titulo} />
                                                <div class="blog-image-cards-row__meta">
                                                    <p class="blog-image-cards-row__tag">{item.categorias?.[0]?.nombre?.toUpperCase()}</p>
                                                    <p class="blog-image-cards-row__meta-text">{formatDate(item.fecha)} · {getReadingTime(item.resumen)}</p>
                                                </div>
                                                <h3 >{item.titulo}</h3>
                                                <p class="blog-image-cards-row__excerpt">{truncateText(item.resumen, 180)}</p>
                                            </a></article>
                                    ))}
                            </div>
                        </section>
                    </div>
                </section>
            </div>
            <div
                arialabel="Más historias móviles" variant="late" className="_nghost-ng-c2676785337">
                <section class="blog-mobile-stories" aria-label="Más historias móviles">
                    <div class="blog-mobile-stories__inner">
                        {!loading && contenido.blogNs.map((item, i) => (

                            <article key={i}
                                class="blog-mobile-stories__story blog-mobile-stories__story--late" tabindex="0">
                                <a href={'/blog/' + item.tag}>
                                    <img
                                        loading="lazy" src={item.urlImagen}
                                        alt={item.titulo} />
                                    <p class="blog-mobile-stories__tag">{item.categorias?.[0]?.nombre?.toUpperCase()}</p>
                                    <p class="blog-mobile-stories__meta">{formatDate(item.fecha)} · {getReadingTime(item.resumen)} DE LECTURA</p>
                                    <h3 >{item.titulo}</h3>
                                    <p class="blog-mobile-stories__excerpt">{truncateText(item.resumen, 110)}</p>
                                </a></article>

                        ))}
                    </div>
                </section>
            </div >
        </>

    );

}

export default Blogs_busq;